




import { Component, Vue } from "vue-property-decorator";
import ActionButton from "@/components/Button/ActionButton.vue";
@Component({
  components: { ActionButton },
})
export default class InfoButton extends Vue {
  public name = "InfoButton";
}
